import { RootState } from './types';
import { GetterTree } from 'vuex';

const filteredTables = (state: RootState) => {
  return state.tables.filter((table: string) => {
    if (table.toLowerCase().includes(state.filterText.toLowerCase())) {
      return table;
    }
  });
};

const loading = (state: RootState) => state.loading;
const tableListLoading = (state: RootState) => state.tableListLoading;
const tables = (state: RootState) => state.tables;
const response = (state: RootState) => state.response;
const currentTable = (state: RootState) => state.currentTable;
const currentDb = (state: RootState) => state.currentDb;
const currentRegion = (state: RootState) => state.currentRegion;
const credentialsExpireAt = (state: RootState) => state.credentialsExpireAt;
const filterText = (state: RootState) => state.filterText;

const getters: GetterTree<RootState, RootState> = {
  loading,
  tableListLoading,
  tables,
  response,
  currentTable,
  currentDb,
  currentRegion,
  credentialsExpireAt,
  filterText,
  filteredTables,
};
export default getters;
